export const DashboardNavbar = {
  LogoDropdown: {},
  HeaderBreadcrumb: {
    fontSize: 'A',
    margin: '- -A - -',
    Button_username: null,
    Button_project: null,
  },
  AddNewButton: {
    extends: [
      'CanvasButton',
      'Button',
    ],
    icon: 'plus',
    padding: 'Z Z2',
    gap: 'X2',
    text: 'New Project',
    aspectRatio: 'none',
    Icon: {
      color: 'blue',
    },
    onClick: async (ev, el) => {
      await el.call('openModal', '/settings', {
        key: '/onboarding'
      })
    },
  },
  DocsSearchHeader: {
    margin: '- auto',
  },
  ThemesInNavbar: {
    margin: '- A2 - -',
  },
  Avatar: {
    fontSize: 'X',
    onClick: async (ev, el) => {
      await el.call('openModal', '/settings', {
        key: '/personal-account'
      })
    },
  },
  extends: 'Navbar',
  gap: 'A2',
  round: 'C1',
  padding: 'W Z2',
  fontSize: 'Z1',
  userSelect: 'none',
  theme: 'common-box',
  position: 'sticky',
  top: 'X',
  left: 'X',
  right: 'X',
  zIndex: 9999999,
};